import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SpecialAboutProperty: React.FunctionComponent<{ property: any, onchangeProperty: any }> = (props) => {
    
    const defaultOptions = ["Open Floor Plan", "Jacuzzi", "Swimming pool", "New roof", "Fayer", "Solar Panel"];
    const [property, setProperty] = useState<any>(props.property || {});
    const [options] = useState<string[]>(defaultOptions);
    const [inputValue, setInputValue] = useState<string>(property.other_desc || "");
    const { t } = useTranslation();

    useEffect(() => {
        if (property.other_desc !== undefined) {
            props.onchangeProperty({ other_desc: property.other_desc });
        }
    }, [property.other_desc]);

    const toggleSelection = (item: string) => {
        setProperty((prev: any) => {
            const currentList = prev.other_desc ? prev.other_desc.split(", ") : [];
            let updatedList;

            if (currentList.includes(item)) {
                // Supprimer si déjà sélectionné
                updatedList = currentList.filter((i: string) => i !== item);
            } else {
                // Ajouter si non sélectionné
                updatedList = [...currentList, item];
            }

            setInputValue(updatedList.join(", ")); // Mettre à jour l'input
            return { ...prev, other_desc: updatedList.join(", ") };
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleSaveOtherDesc = () => {
        setProperty((prev: any) => ({
            ...prev,
            other_desc: inputValue.trim()
        }));
    };

    return (
        <>
            <h3 className="title-20 title-18-mb color-black mb-4">{t("propertyDetails.specialAbout")}
            </h3>
            <div className="row card-form mb-4">
                <div className="padd-00">
                    <input
                        type="text"
                        className="form-control selected-items mb-2"
                        placeholder={t("generateDescTitle.enterorSelectFeatures")}
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleSaveOtherDesc}
                        onKeyDown={(e) => e.key === "Enter" && handleSaveOtherDesc()}
                    />
                    <div className="chips-container mt-3">
                        {options.map((item, index) => (
                            <button
                                key={index}
                                className={`chip ${property.other_desc && property.other_desc.includes(item) ? "selected" : ""}`}
                                onClick={() => toggleSelection(item)}
                            >
                                {t(`propertyDetails.${item}`)}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SpecialAboutProperty;
